import { gql } from '@apollo/client';

export const FETCH_COMMERCIAL_MEMBERSHIP_PLANS = gql`
  query FetchAllMemberships($limit: Int, $offset: Int) {
    fetchAllMemberships(limit: $limit, offset: $offset) {
        data {
            id
            membership_duration_id
            membership_end_date
            membership_join_date
            user_id
            membership_details {
                created_at
                description
                duration_type
                id
                number_of_days
                package_id
                price
                updated_at
                package {
                    created_at
                    description
                    id
                    name
                    package_type
                    updated_at
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;

export const FETCH_COMMERCIAL_MEMBERSHIP_SUMMARY = gql`
  query FetchMembershipSummary($membership_duration_id:UUID!) {
    fetchMembershipSummary(membership_duration_id: $membership_duration_id) {
        data {
            duration_type
            id
            product
        }
        error {
            code
            field
            message
        }
    }
}

`;


